import React, { useState } from 'react';
import Select from 'react-select';

const TeamDirectoryModal = ({ isOpen, setIsOpen }) => {

    const [skills, setSkills] = useState([]); // Array to store final skills
    const [skillsInput, setSkillsInput] = useState(''); // Temporary raw input for skills

    const [languages, setLanguages] = useState([]);
    const [languagesInput, setLanguagesInput] = useState('');

    const [hobbies, setHobbies] = useState([]);
    const [hobbiesInput, setHobbiesInput] = useState('');

    const handleBlurOrEnter = (setter, inputSetter, value) => {
        const values = value
            .split(",")
            .map((item) => item.trim())
            .filter((item) => item); // Removes empty items
        setter((prev) => [...prev, ...values]); // Append new values to existing ones
        inputSetter(""); // Clear input field
    };

    const removeTag = (setter, indexToRemove) => {
        setter((prev) => prev.filter((_, index) => index !== indexToRemove));
    };

    const genderOptions = [
        { value: 'male', label: 'Male' },
        { value: 'female', label: 'Female' },
        { value: 'other', label: 'Other' },
    ];

    const departmentOptions = [
        { value: 'hr', label: 'HR' },
        { value: 'engineering', label: 'Engineering' },
        { value: 'sales', label: 'Sales' },
    ];

    const employmentStatusOptions = [
        { value: 'full-time', label: 'Full-Time' },
        { value: 'part-time', label: 'Part-Time' },
        { value: 'contract', label: 'Contract' },
    ];

    const maritalStatusOptions = [
        { value: 'single', label: 'Single' },
        { value: 'married', label: 'Married' },
        { value: 'divorced', label: 'Divorced' },
    ];

    // Prevent rendering modal if it is not open
    if (!isOpen) {
        return null;
    }

    // Debugging: Log hobbies to see its state
    console.log('Is hobbies array:', Array.isArray(hobbies), hobbies); // Check if 'hobbies' is an array

    return (
        <div className="custom-modal-overlay" onClick={() => setIsOpen(false)}>
            <div
                className="custom-modal-content"
                onClick={(e) => e.stopPropagation()} // Prevent closing on content click
            >
                <h2 className="oms-modal-title">Employee Details</h2>
                <form className="oms-modal-form">
                    {/* Basic Information */}
                    <h3>Basic Information</h3>
                    <div className="oms-form-flex">
                        <div className="oms-form-group">
                            <label htmlFor="fullName" className="oms-form-label">Full Name</label>
                            <input type="text" id="fullName" placeholder="Enter full name" />
                        </div>
                        <div className="oms-form-group">
                            <label htmlFor="employeeId" className="oms-form-label">Employee ID</label>
                            <input type="text" id="employeeId" placeholder="Enter employee ID" />
                        </div>
                        <div className="oms-form-group">
                            <label htmlFor="dob" className="oms-form-label">Date of Birth</label>
                            <input type="date" id="dob" />
                        </div>
                        <div className="oms-form-group">
                            <label htmlFor="gender" className="oms-form-label">Gender</label>
                            <Select options={genderOptions} placeholder="Select gender" />
                        </div>
                        <div className="oms-form-group">
                            <label htmlFor="photo" className="oms-form-label">Photo</label>
                            <input type="file" id="photo" accept="image/*" />
                        </div>
                    </div>

                    {/* Contact Information */}
                    <h3>Contact Information</h3>
                    <div className="oms-form-flex">
                        <div className="oms-form-group">
                            <label htmlFor="address" className="oms-form-label">Address</label>
                            <input type="text" id="address" placeholder="Enter address" />
                        </div>
                        <div className="oms-form-group">
                            <label htmlFor="phoneNumber" className="oms-form-label">Phone Number</label>
                            <input type="tel" id="phoneNumber" placeholder="Enter phone number" />
                        </div>
                        <div className="oms-form-group">
                            <label htmlFor="email" className="oms-form-label">Email ID</label>
                            <input type="email" id="email" placeholder="Enter email ID" />
                        </div>
                        <div className="oms-form-group">
                            <label htmlFor="emergencyPhone" className="oms-form-label">Emergency Phone Number</label>
                            <input type="tel" id="emergencyPhone" placeholder="Enter emergency phone number" />
                        </div>
                    </div>

                    {/* Employment Detail */}
                    <h3>Employment Detail</h3>
                    <div className="oms-form-flex">
                        <div className="oms-form-group">
                            <label htmlFor="jobTitle" className="oms-form-label">Job Title</label>
                            <input type="text" id="jobTitle" placeholder="Enter job title" />
                        </div>
                        <div className="oms-form-group">
                            <label htmlFor="department" className="oms-form-label">Department</label>
                            <Select options={departmentOptions} placeholder="Select department" />
                        </div>
                        <div className="oms-form-group">
                            <label htmlFor="dateOfJoining" className="oms-form-label">Date of Joining</label>
                            <input type="date" id="dateOfJoining" />
                        </div>
                        <div className="oms-form-group">
                            <label htmlFor="employmentStatus" className="oms-form-label">Employment Status</label>
                            <Select options={employmentStatusOptions} placeholder="Select status" />
                        </div>
                        <div className="oms-form-group">
                            <label htmlFor="reportingManager" className="oms-form-label">Reporting Manager</label>
                            <input type="text" id="reportingManager" placeholder="Enter reporting manager" />
                        </div>
                        <div className="oms-form-group">
                            <label htmlFor="classLocation" className="oms-form-label">Class Location</label>
                            <input type="text" id="classLocation" placeholder="Enter class location" />
                        </div>
                    </div>

                    {/* Professional Information */}
                    <h3>Professional Information</h3>
                    <div className="oms-form-flex">
                        <div className="oms-form-group">
                            <label htmlFor="qualification" className="oms-form-label">Qualification</label>
                            <input type="text" id="qualification" placeholder="Enter qualification" />
                        </div>
                        <div className="oms-form-group">
                            <label htmlFor="experience" className="oms-form-label">Previous Experience</label>
                            <input type="text" id="experience" placeholder="Enter previous experience" />
                        </div>
                        {/* Skills */}
                        <div className="oms-form-group">
                            <label htmlFor="skills" className="oms-form-label">Skills</label>
                            <input
                                type="text"
                                id="skills"
                                placeholder="Enter skills separated by commas"
                                value={skillsInput} // Raw input text
                                onChange={(e) => setSkillsInput(e.target.value)} // Update raw input
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        e.preventDefault();
                                        handleBlurOrEnter(setSkills, setSkillsInput, skillsInput);
                                    }
                                }}
                                onBlur={() => handleBlurOrEnter(setSkills, setSkillsInput, skillsInput)}
                            />
                            <div>
                                {skills.map((skill, index) => (
                                    <span key={index} className="tag">{skill}
                                        <button
                                            type="button"
                                            className="remove-tag-btn"
                                            onClick={() => removeTag(setSkills, index)}
                                        >
                                            ×
                                        </button>
                                    </span>
                                ))}
                            </div>
                        </div>
                        {/* Languages */}
                        <div className="oms-form-group">
                            <label htmlFor="languages" className="oms-form-label">Languages</label>
                            <input
                                type="text"
                                id="languages"
                                placeholder="Enter languages separated by commas"
                                value={languagesInput}
                                onChange={(e) => setLanguagesInput(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        e.preventDefault();
                                        handleBlurOrEnter(setLanguages, setLanguagesInput, languagesInput);
                                    }
                                }}
                                onBlur={() => handleBlurOrEnter(setLanguages, setLanguagesInput, languagesInput)}
                            />
                            <div>
                                {languages.map((language, index) => (
                                    <span key={index} className="tag">{language}
                                        <button
                                            type="button"
                                            className="remove-tag-btn"
                                            onClick={() => removeTag(setLanguages, index)}
                                        >
                                            ×
                                        </button>
                                    </span>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* Payroll Information */}
                    <h3>Payroll Information</h3>
                    <div className="oms-form-flex">
                        <div className="oms-form-group">
                            <label htmlFor="accountNo" className="oms-form-label">Account Number</label>
                            <input type="text" id="accountNo" placeholder="Enter account number" />
                        </div>
                        <div className="oms-form-group">
                            <label htmlFor="ifscCode" className="oms-form-label">IFSC Code</label>
                            <input type="text" id="ifscCode" placeholder="Enter IFSC code" />
                        </div>
                        <div className="oms-form-group">
                            <label htmlFor="bankName" className="oms-form-label">Bank Name</label>
                            <input type="text" id="bankName" placeholder="Enter bank name" />
                        </div>
                        <div className="oms-form-group">
                            <label htmlFor="providentFund" className="oms-form-label">Provident Fund</label>
                            <input type="text" id="providentFund" placeholder="Enter provident fund" />
                        </div>
                    </div>

                    {/* Other Information */}
                    <h3>Other Information</h3>
                    <div className="oms-form-flex">
                        <div className="oms-form-group">
                            <label htmlFor="maritalStatus" className="oms-form-label">Marital Status</label>
                            <Select options={maritalStatusOptions} placeholder="Select marital status" />
                        </div>
                        {/* Hobbies */}
                        <div className="oms-form-group">
                            <label htmlFor="hobbies" className="oms-form-label">Hobbies</label>
                            <input
                                type="text"
                                id="hobbies"
                                placeholder="Enter hobbies separated by commas"
                                value={hobbiesInput}
                                onChange={(e) => setHobbiesInput(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        e.preventDefault();
                                        handleBlurOrEnter(setHobbies, setHobbiesInput, hobbiesInput);
                                    }
                                }}
                                onBlur={() => handleBlurOrEnter(setHobbies, setHobbiesInput, hobbiesInput)}
                            />
                            <div>
                                {hobbies.map((hobby, index) => (
                                    <span key={index} className="tag">{hobby}
                                        <button
                                            type="button"
                                            className="remove-tag-btn"
                                            onClick={() => removeTag(setHobbies, index)}
                                        >
                                            ×
                                        </button>
                                    </span>
                                ))}
                            </div>
                        </div>
                    </div>

                    <div className="oms-form-actions">
                        <button type="button" onClick={() => setIsOpen(false)}>
                            Cancel
                        </button>
                        <button type="submit">Submit</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default TeamDirectoryModal;
